module.exports = __webpack_public_path__ + "img/byte__logo.b94b26d7.png";